import { useEffect } from 'react'

import { logPageView } from '@/analytics'

export const SUPPORT_EMBED_PATH = '/soutien/panneau'

const piloteOrigin = () => new URL(import.meta.env.VITE_PILOTE_BASE_URL).origin

export type SupportFrameMessage =
  | { readonly type: 'soutien:ready' }
  | { readonly type: 'soutien:badge'; readonly count: number }
  | { readonly type: 'soutien:close' }

export const isSupportEmbed = () =>
  globalThis.location.pathname === SUPPORT_EMBED_PATH && globalThis.parent !== globalThis.window

export const isPiloteUrl = (url: string) => URL.canParse(url) && new URL(url).origin === piloteOrigin()

export const isSupportObjectUrl = (url: string) =>
  URL.canParse(url) && [piloteOrigin(), globalThis.location.origin].includes(new URL(url).origin)

export const postToPilote = (message: SupportFrameMessage) => {
  globalThis.parent.postMessage(message, piloteOrigin())
}

const isOpenRequest = (event: MessageEvent<unknown>) =>
  event.origin === piloteOrigin() &&
  event.source === globalThis.parent &&
  typeof event.data === 'object' &&
  event.data !== null &&
  'type' in event.data &&
  event.data.type === 'soutien:open'

export const usePiloteFrame = (onOpen?: () => void) => {
  useEffect(() => {
    const listener = (event: MessageEvent<unknown>) => {
      if (isOpenRequest(event)) {
        logPageView(SUPPORT_EMBED_PATH)
        onOpen?.()
      }
    }
    globalThis.addEventListener('message', listener)
    postToPilote({ type: 'soutien:ready' })
    return () => {
      globalThis.removeEventListener('message', listener)
    }
  }, [onOpen])
}

export const usePiloteBadge = (count: number) => {
  useEffect(() => {
    postToPilote({ type: 'soutien:badge', count })
  }, [count])
}
